import { useEffect, useState } from "react";
import dropin from "braintree-web-drop-in";
import api from "../../api";
import { useAlert } from "react-alert";

export default function BTCheckout({ userId, handleClose }) {
  const [instance, setInstance] = useState(null);
  const alert = useAlert();

  useEffect(() => {
    async function init() {
      let payload = {
        _id: userId,
      };
      const data = await api.createBtSubscriptionToken(payload);
      console.log("data");
      console.log(data);

      dropin.create(
        {
          authorization: data.clientToken,
          container: "#dropin-container",
          googlePay: {
            googlePayVersion: 2,
            merchantId: "your-googlepay-merchant-id",
            transactionInfo: {
              totalPriceStatus: "FINAL",
              totalPrice: "10.00",
              currencyCode: "USD",
            },
          },
        },
        (err, dropinInstance) => {
          if (err) console.error(err);
          setInstance(dropinInstance);
          console.log("set instance:");
          console.log(dropinInstance);

          // instance.on("paymentMethodRequestable", async () => {
          //   // auto create subscription once user confirms payment UI
          //   const { nonce } = await instance.requestPaymentMethod();
          //   await api.subscribeUser({ paymentMethodNonce: nonce, userId });
          //   alert("Subscription Active!");
          // });
        }
      );
    }
    init();
  }, [userId]);

  // 💥 CRITICAL FIX
  useEffect(() => {
    return () => {
      if (instance) {
        // instance.teardown();
        setInstance(null);
      }
    };
  }, [instance]);

  const handleSubscribe = async () => {
    if (!instance) return;
    const { nonce } = await instance.requestPaymentMethod();
    console.log(nonce);

    let payload = { paymentMethodNonce: nonce, userId };
    const data = await api.createBtSubscription(payload);
    if (data.subscriptionId) {
      alert.show(
        "WAIT A WHILE, WE WILL SHARE YOU AN EMAIL ONCE SUBSCRIPPTION CREATED."
      );
      handleClose();
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };

  return (
    <div>
      <div id="dropin-container" />
      <button className="themeBtn mx-auto mt-2" onClick={handleSubscribe}>
        Subscribe
      </button>
    </div>
  );
}
